exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".content>p[data-v-64833276],.content p[data-v-64833276]:not(:last-child){margin-bottom:0}.content>ul[data-v-64833276]{padding:0 1em;list-style-type:disc}.content>ol[data-v-64833276]{padding:0 1.25em}.is-clickable[data-v-64833276]{cursor:pointer}", ""]);

// exports
